// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2ZZD2","title":"card_title__1CH0-","inActive":"card_inActive__3euYL"};